module.exports = __webpack_public_path__ + "europa-100-microprint.jpg?257ee4191ae6de357ecfb384a043d8b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-100-microprint.jpg
// module id = 257
// module chunks = 0